import CommonFooter from '../../common/Footer';
import ForgotPasswordLink from '../ForgotPasswordLink';
import { generateFooters } from '../../../utils/react-utils';

export default function Footer({
  footerLinks,
  forgotPasswordLink,
}: {
  footerLinks: JQuery;
  forgotPasswordLink: boolean;
}) {
  const footers = generateFooters({
    footerLinks,
    alwaysDisplayBackToSignIn: false,
  });

  if (forgotPasswordLink) {
    footers.push(
      <div key={'forgot-password'}>
        <ForgotPasswordLink />
      </div>
    );
  }
  return <CommonFooter reactFooters={footers} />;
}
